interface IRedirect {
  path: string
  urls: { [key: string]: string | null }
}

export const redirects: IRedirect[] = [
  // A null for country URL means don't redirect
  { path: '/test', urls: { default: '/test', ie: null } },
  { path: '/nl/test', urls: { default: '/testnl', uk: null, ie: null } },
  { path: '/city-trip', urls: { default: '/' } },
  { path: '/nl/city-trip', urls: { nl: '/' } },
  { path: '/be/city-trip', urls: { be: '/' } },
  { path: '/pick-a-side', urls: { default: '/' } },
  { path: '/nl/pick-a-side', urls: { nl: '/' } },
  { path: '/be/pick-a-side', urls: { be: '/' } },
  { path: '/broke', urls: { default: '/' } },
  { path: '/nl/broke', urls: { nl: '/' } },
  { path: '/be/broke', urls: { be: '/' } },
  { path: '/road-trip', urls: { default: '/' } },
  { path: '/nl/road-trip', urls: { nl: '/' } },
  { path: '/be/road-trip', urls: { be: '/' } },
  { path: '/multi-city', urls: { default: '/' } },
  { path: '/nl/multi-city', urls: { nl: '/' } },
  { path: '/be/multi-city', urls: { be: '/' } },
  { path: '/backpacking', urls: { default: '/' } },
  { path: '/nl/backpacking', urls: { nl: '/' } },
  { path: '/be/backpacking', urls: { be: '/' } },
  { path: '/citybreak', urls: { default: '/' } },
  { path: '/uk/citybreak', urls: { default: '/' } },
  { path: '/ie/citybreak', urls: { default: '/' } },
  { path: '/giftcardgeven', urls: { default: '/redeem-giftcard' } },
  { path: '/nl/giftcardgeven', urls: { nl: '/cadeaubon' } },
  { path: '/be/giftcardgeven', urls: { be: '/cadeaubon' } },
  // {path: "/bolbol", urls: {nl: "/bonbon", be: "/bonbon", uk: "/srprs-gift", ie: "/srprs-gift"}},
  { path: '/themas-vergelijken', urls: { default: '/' } },
  { path: '/nl/themas-vergelijken', urls: { nl: '/' } },
  { path: '/be/themas-vergelijken', urls: { be: '/' } },
  { path: '/hoe-werkt-het', urls: { default: '/hoe-het-werk' } },
  { path: '/nl/hoe-werkt-het', urls: { nl: '/hoe-het-werk' } },
  { path: '/be/hoe-werkt-het', urls: { be: '/hoe-het-werk' } },
  { path: '/themas', urls: { default: '/' } },
  { path: '/nl/themas', urls: { nl: '/' } },
  { path: '/be/themas', urls: { default: '/' } },
  { path: '/themas', urls: { default: '/' } },
  { path: '/uk/themas', urls: { default: '/' } },
  { path: '/ie/themas', urls: { default: '/' } },
  { path: '/reviews', urls: { default: '/' } },
  { path: '/nl/reviews', urls: { default: '/' } },
  { path: '/be/reviews', urls: { default: '/' } },
  { path: '/uk/reviews', urls: { default: '/' } },
  { path: '/ie/reviews', urls: { default: '/' } },
  { path: '/faq', urls: { default: '/contact-support' } },
  { path: '/nl/faq', urls: { nl: '/contact-support' } },
  { path: '/be/faq', urls: { be: '/contact-support' } },
  { path: '/uk/faq', urls: { uk: '/contact-support' } },
  { path: '/ie/faq', urls: { ie: '/contact-support' } },
  { path: '/manifest', urls: { default: '/' } },
  { path: '/nl/manifest', urls: { nl: '/' } },
  { path: '/be/manifest', urls: { default: '/' } },
  { path: '/manifesto', urls: { default: '/' } },
  { path: '/nl/manifesto', urls: { nl: '/' } },
  { path: '/be/manifesto', urls: { default: '/' } },
  { path: '/werken-bij', urls: { default: '/over-ons' } },
  { path: '/nl/werken-bij', urls: { nl: '/over-ons' } },
  { path: '/be/werken-bij', urls: { be: '/over-ons' } },
  { path: '/klantenservice', urls: { default: '/contact-support' } },
  { path: '/nl/klantenservice', urls: { nl: '/contact-support' } },
  { path: '/be/klantenservice', urls: { be: '/contact-support' } },
  { path: '/customer-service', urls: { default: '/contact-support' } },
  { path: '/uk/customer-service', urls: { uk: '/contact-support' } },
  { path: '/ie/customer-service', urls: { ie: '/contact-support' } },
  { path: '/zekerheden', urls: { default: '/algemene-voorwaarden' } },
  { path: '/terms-and-conditions', urls: { default: '/terms-conditions' } },
  { path: '/uk/terms-and-conditions', urls: { uk: '/terms-conditions' } },
  { path: '/ie/terms-and-conditions', urls: { ie: '/terms-conditions' } },
  { path: '/privacy-policy', urls: { default: '/privacypolicy' } },
  { path: '/uk/privacy-policy', urls: { uk: '/privacypolicy' } },
  { path: '/ie/privacy-policy', urls: { ie: '/privacypolicy' } },
  { path: '/klaas', urls: { default: '/' } },
  { path: '/nl/klaas', urls: { nl: '/' } },
  { path: '/be/klaas', urls: { be: '/' } },
  {
    path: '/spooradisch',
    urls: { nl: '/thema-van-de-maand', be: '/thema-van-de-maand' },
  },
  {
    path: '/surf-beach',
    urls: {
      nl: '/thema-van-de-maand',
      be: '/thema-van-de-maand',
      uk: '/special-edition',
    },
  },
  { path: '/surprise', urls: { default: '/' } },
  { path: '/thema-van-de-maand', urls: { default: '/' } },
  { path: '/special-edition', urls: { default: '/solo-together' } },
  { path: '/nl/thema-van-de-maand', urls: { default: '/' } },
  { path: '/be/thema-van-de-maand', urls: { default: '/' } },
  { path: '/uk/special-edition', urls: { uk: '/solo-together' } },

  // Marketing pages
  {
    path: '/giveandtake',
    urls: { nl: '/korting/give-and-take', be: '/korting/give-and-take' },
  },

  // Lead Generation campaign
  {
    path: '/nl/3uithoeken/actievoorwaarden',
    urls: { nl: '/win/actievoorwaarden' },
  },
  {
    path: '/nl/3uithoeken/:friendCode?/:code?',
    urls: { nl: '/win/:friendCode?/:code?' },
  },
  {
    path: '/nl/3uithoeken/deelnemer/:code',
    urls: { nl: '/win/deelnemer/:code' },
  },
  {
    path: '/be/3uithoeken/actievoorwaarden',
    urls: { be: '/win/actievoorwaarden' },
  },
  {
    path: '/be/3uithoeken/:friendCode?/:code?',
    urls: { be: '/win/:friendCode?/:code?' },
  },
  {
    path: '/be/3uithoeken/deelnemer/:code?',
    urls: { be: '/win/deelnemer/:code?' },
  },
  {
    path: '/uk/3corners/terms-and-conditions',
    urls: { uk: '/win/terms-and-conditions' },
  },
  {
    path: '/uk/3corners/:friendCode?/:code?',
    urls: { uk: '/win/:friendCode?/:code?' },
  },
  {
    path: '/uk/3corners/participant/:code?',
    urls: { uk: '/win/participant/:code?' },
  },
  {
    path: '/ie/3corners/terms-and-conditions',
    urls: { ie: '/win/terms-and-conditions' },
  },
  {
    path: '/ie/3corners/:friendCode?/:code?',
    urls: { ie: '/win/:friendCode?/:code?' },
  },
  {
    path: '/ie/3corners/participant/:code?',
    urls: { ie: '/win/participant/:code?' },
  },
  {
    path: '/win',
    urls: { dk: '/win', nl: `/win`, be: `/win`, ie: '/win', uk: '/win' },
  },

  // SEO Plan
  {
    path: '/nl/hoe-het-werkt/vliegreis',
    urls: { nl: '/hoe-het-werkt/verrassingsreis-vliegtuig' },
  },
  {
    path: '/nl/hoe-het-werkt/autoreis',
    urls: { nl: '/hoe-het-werkt/verrassingsreis-auto' },
  },
  {
    path: '/uk/how-it-works/fly',
    urls: { uk: '/how-it-works/srprs-trip-fly' },
  },
  { path: '/nl/srprs-gift', urls: { nl: '/cadeaubon' } },
  { path: '/be/srprs-gift', urls: { be: '/cadeaubon' } },
  { path: '/nl/bonbon', urls: { nl: '/cadeaubon-verzilveren' } },
  { path: '/be/bonbon', urls: { be: '/cadeaubon-verzilveren' } },
  { path: '/nl/vliegreis/extras', urls: { nl: '/vliegreis/extras-bijboeken' } },
  { path: '/be/vliegreis/extras', urls: { be: '/vliegreis/extras-bijboeken' } },
  {
    path: '/nl/vliegreis/meerderesteden/extras',
    urls: { nl: '/vliegreis/meerderesteden/extras-bijboeken' },
  },
  {
    path: '/be/vliegreis/meerderesteden/extras',
    urls: { be: '/vliegreis/meerderesteden/extras-bijboeken' },
  },
  { path: '/nl/entry/in-control', urls: { nl: '/verrassingsreis/in-control' } },
  { path: '/be/entry/in-control', urls: { be: '/verrassingsreis/in-control' } },
  {
    path: '/nl/entry/solo-together',
    urls: { nl: '/verrassingsreis/solo-together' },
  },
  {
    path: '/be/entry/solo-together',
    urls: { be: '/verrassingsreis/solo-together' },
  },
  { path: '/nl/entry/multi-city', urls: { nl: '/verrassingsreis/multi-city' } },
  { path: '/be/entry/multi-city', urls: { be: '/verrassingsreis/multi-city' } },
  {
    path: '/nl/entry/nieuwe-bestemmingen',
    urls: { nl: '/verrassingsreis/nieuwe-bestemmingen' },
  },
  {
    path: '/be/entry/nieuwe-bestemmingen',
    urls: { be: '/verrassingsreis/nieuwe-bestemmingen' },
  },
  {
    path: '/nl/entry/beste-prijs',
    urls: { nl: '/verrassingsreis/beste-prijs' },
  },
  {
    path: '/be/entry/beste-prijs',
    urls: { be: '/verrassingsreis/beste-prijs' },
  },
  { path: '/nl/entry/favoriet', urls: { nl: '/verrassingsreis/favoriet' } },
  { path: '/be/entry/favoriet', urls: { be: '/verrassingsreis/favoriet' } },
  { path: '/nl/autoreis/extras', urls: { nl: '/autoreis/extras-bijboeken' } },
  { path: '/be/autoreis/extras', urls: { be: '/autoreis/extras-bijboeken' } },
  {
    path: '/nl/autoreis/meerderesteden/extras',
    urls: { nl: '/autoreis/meerderesteden/extras-bijboeken' },
  },
  {
    path: '/be/autoreis/meerderesteden/extras',
    urls: { be: '/autoreis/meerderesteden/extras-bijboeken' },
  },
  {
    path: '/nl/entry/auto-beste-prijs',
    urls: { nl: '/verrassingsreis/autoreis-beste-prijs' },
  },
  {
    path: '/be/entry/auto-beste-prijs',
    urls: { be: '/verrassingsreis/autoreis-beste-prijs' },
  },
  {
    path: '/nl/entry/auto-favoriet',
    urls: { nl: '/verrassingsreis/autoreis-favoriet' },
  },
  {
    path: '/be/entry/auto-favoriet',
    urls: { be: '/verrassingsreis/autoreis-favoriet' },
  },
  {
    path: '/nl/entry/multi-road',
    urls: { nl: '/verrassingsreis/multi-roadtrip' },
  },
  {
    path: '/be/entry/multi-road',
    urls: { be: '/verrassingsreis/multi-roadtrip' },
  },
  {
    path: '/nl/entry/roadtrip-xl',
    urls: { nl: '/verrassingsreis/roadtrip-xl' },
  },
  {
    path: '/be/entry/roadtrip-xl',
    urls: { be: '/verrassingsreis/roadtrip-xl' },
  },
  { path: '/nl/samenvatting', urls: { nl: '/reissamenstelling-controleren' } },
  { path: '/be/samenvatting', urls: { be: '/reissamenstelling-controleren' } },
  { path: '/uk/srprs-gift', urls: { uk: '/giftcard' } },
  { path: '/ie/srprs-gift', urls: { ie: '/giftcard' } },
  { path: '/uk/fly/customise', urls: { uk: '/fly/customise-trip' } },
  { path: '/ie/fly/customise', urls: { ie: '/fly/customise-trip' } },
  { path: '/uk/fly/extras', urls: { uk: '/fly/add-extras' } },
  { path: '/ie/fly/extras', urls: { ie: '/fly/add-extras' } },
  { path: '/uk/entry/in-control', urls: { uk: '/srprs-trip/in-control' } },
  { path: '/ie/entry/in-control', urls: { ie: '/srprs-trip/in-control' } },
  { path: '/uk/entry/best-price', urls: { uk: '/srprs-trip/best-price' } },
  { path: '/ie/entry/best-price', urls: { ie: '/srprs-trip/best-price' } },
  { path: '/uk/entry/favourite', urls: { uk: '/srprs-trip/favourite' } },
  { path: '/ie/entry/favourite', urls: { ie: '/srprs-trip/favourite' } },
  { path: '/uk/summary', urls: { uk: '/trip-summary' } },
  { path: '/ie/summary', urls: { ie: '/trip-summary' } },
]

export const absoluteRedirects = { '/tube': '/uk/tube' }
